export default __webpack_public_path__ + "static/studycafe-firenze1-190a4ed01f0906360cf2c6904d2974ba.jpg";